import { EquipmentItem } from "@/backend/models/equipmentItem";
import { useEquipmentStore } from "@/frontend/store/EquipmentStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { useShallow } from "zustand/react/shallow";
import { CurrentInstrumentTable } from "../equipment/EquipmentTable";
import { SelectEquipment } from "./AddEquipmentButton";
import { Operation } from "@/backend/models/operation";


export function EquipmentOperation(props: { operation: Operation }) {
  const { operation } = props;
  const equipment = useEquipmentStore(useShallow(state => state.equipmentList)) .find(({ id }) => id === operation.equipmentId);
  const updateOperation = useTreeStore(state => state.updateOperation);

  const onSelectEquipment = (equipmentItem: EquipmentItem) => {
    void updateOperation({ operation: { ...operation, equipmentId: equipmentItem.id } });
  };

  if (!equipment) {
    return <SelectEquipment onSelect={onSelectEquipment} />;
  }

  return <CurrentInstrumentTable showDescription isEditable equipment={[equipment]} />;
}
